import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Group = styled.div<{ $direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${(p) => p.$direction};
  gap: ${space[4]};
`;
